import { GeoJSON } from 'react-leaflet'
import * as React from 'react'
import L from 'leaflet';
import {
    DisplayFeature, CommonAssociationFeature
} from '../../../contract-features-3/domain';
import {GeometryObject} from "geojson";
import {RefObject} from "react";
import {PathOptions} from "leaflet";
import classNames = require("classnames");


export enum MarkerType{
    MOTHER,
    TARGET
}

interface FeatureLayerProps {
    feature: CommonAssociationFeature|DisplayFeature,
    isSelected: boolean,
    featureClicked: () => void,
    markerType: MarkerType,
    isAssociated: boolean,
    data: GeometryObject
}

export default class FeatureLayer extends React.Component<FeatureLayerProps> {

    private readonly ref: RefObject<GeoJSON>;

    constructor(props: FeatureLayerProps) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount(){
        if (this.props.markerType == MarkerType.MOTHER){
            this.bringToBack();
        }
    }

    componentDidUpdate (prevProps: Readonly<FeatureLayerProps>) {
        this.updateSVGPathClasses();
    }

    private bringToBack(){
        if (this.ref.current) {
            this.ref.current.leafletElement.bringToBack();
        }
    }

    private featureClicked = () => {
        this.props.featureClicked();
    };

    private pointToLayer = (mapFeature: any, latLng: L.LatLngExpression) => {
        const radius = this.props.isSelected ? 7 : 5;
        return L.circleMarker(latLng, {className: 'pointMarker', radius: radius});
    };

    /**
     * Update classes for Leaflet SVG path element after initial render. Leaflet has
     * a bug (https://github.com/leaflet/leaflet/issues/2662) where changes to the "className" field
     * in the style set is ignored after initial render.
     */
    updateSVGPathClasses() {
        let {isSelected, isAssociated, markerType } = this.props;
        if (this.ref.current) {
            if (isSelected) {
                this.ref.current.leafletElement.bringToFront();
            }

            let layers = this.ref.current.leafletElement.getLayers();
            layers.forEach(l => {
                let path: Element = (l as any)._path; // _path is set to protected in typings

                // No path element probably means that render is not complete yet, in which case render() will set classes
                if (path) {
                    if(isSelected) {
                        path.classList.add("selectedMarker");
                    } else {
                        path.classList.remove("selectedMarker");
                    }
                    if(isAssociated) {
                        path.classList.add("associatedMarker");
                    } else {
                        path.classList.remove("associatedMarker");
                    }

                    path.classList.add("marker");
                    path.classList.add(markerType == MarkerType.MOTHER ? "mother" : "target");
                }
            })
        }
    }

    render(): React.ReactNode {
        const {markerType, isSelected, isAssociated} = this.props;

        // These classes are only used on initial render, see updateSVGPathClasses()
        let classes = classNames({
            "marker": true,
            "mother": markerType === MarkerType.MOTHER,
            "target": markerType !== MarkerType.MOTHER,
            "selectedMarker": isSelected,
            "associatedMarker": isAssociated
        });

        const style: PathOptions = {
            weight: 1,
            fillOpacity: 0.7,
            className: classes
        };

        return <GeoJSON data={this.props.data}
                        onclick={this.featureClicked}
                        pointToLayer={this.pointToLayer}
                        style={style}
                        ref={this.ref} />
    }
}
